import { useState } from 'react';
import { PortfolioVoucherOverview } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Tab, Tabs } from '@optimus-web/core';
import { VoucherCodesTable } from '../VoucherCodesTable/VoucherCodesTable';
import { ModalSidePanel } from '../../../../../../components';

interface VoucherDetailsProps {
    voucher: PortfolioVoucherOverview | undefined;
    isOpened: boolean;
    onClose: () => void;
    onUnmount: () => void;
}

enum VoucherTabValues {
    VoucherCodes = 'voucherCodes',
}

export const VoucherDetails = ({ voucher, isOpened, onClose, onUnmount }: VoucherDetailsProps) => {
    const [activeTab, setActiveTab] = useState<string>(VoucherTabValues.VoucherCodes);

    const content = voucher && (
        <Stack spacing="400" vertical>
            <Tabs inline activeTabValue={activeTab} onTabClick={(event, value) => setActiveTab(value)}>
                <Tab
                    inline
                    id={VoucherTabValues.VoucherCodes}
                    value={VoucherTabValues.VoucherCodes}
                    label={<LocalizedText textKey={TextKey.VoucherCodeTabTitle} />}
                />
            </Tabs>

            <VoucherCodesTable voucher={voucher} />
        </Stack>
    );

    return (
        <ModalSidePanel
            opened={isOpened}
            title={voucher?.name}
            onClose={onClose}
            onUnmount={onUnmount}
            content={content}
            width="large"
            headerActions={null}
            key={voucher?.id}
        />
    );
};
